<template>
  <div class="legal-page">
    <div class="reading-progress"></div>

    <nav class="navbar navbar-scrolled">
      <div class="logo" @click="$router.push('/')">LAIQIU<span>来秋</span></div>
      <div class="nav-links"></div>
      <button class="back-btn" @click="$router.back()">← 返回</button>
    </nav>

    <header class="article-hero">
      <div class="hero-bg"
        style="background-image: url('https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2000')"></div>
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <div class="article-meta">
          <span class="category">TERMS</span>
          <span class="dot">·</span>
          <span class="time">2026.01.01</span>
        </div>
        <h1>服务协议</h1>
        <p class="excerpt">使用本网站即表示你同意以下条款</p>
      </div>
    </header>

    <main class="article-container">
      <article class="content-body">
        <div class="ai-summary-box">
          <div class="ai-header">✧ 协议摘要</div>
          <p>本站仅供学习交流使用，禁止商用、侵权、违法用途，违规使用责任自负。</p>
        </div>

        <section class="markdown-render">
          <h2>1. 使用范围</h2>
          <p>本站所有内容仅供学习、研究、欣赏，禁止任何商业用途。</p>

          <h2>2. 禁止行为</h2>
          <p>禁止复制、篡改、传播本站内容用于盈利、侵权、违法活动。</p>

          <h2>3. 内容权利</h2>
          <p>本站内容版权归属原作者与 LAIQIU 社区所有。</p>

          <h2>4. 免责声明</h2>
          <p>本站不保证服务绝对稳定，不承担因使用本站产生的任何风险。</p>

          <h2>5. 协议修改</h2>
          <p>我们保留随时修改本协议的权利，继续使用视为接受更新。</p>
        </section>
      </article>
    </main>

    <footer class="simple-footer">
      <p>© 2026 LAIQIU COMMUNITY · 科技以人文的方式着陆</p>
    </footer>
  </div>
</template>

<style scoped>
/* 与 Privacy.vue 完全相同，直接复制即可 */
.legal-page {
  background: #050505;
  color: #fff;
  min-height: 100vh;
  font-family: 'Inter', 'PingFang SC', sans-serif;
}

.reading-progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #6d5dfc, #00d2ff);
  z-index: 2000;
  box-shadow: 0 0 10px rgba(109, 93, 252, 0.5);
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1rem 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  background: rgba(5, 5, 5, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.logo {
  font-size: 1.5rem;
  font-weight: 800;
  cursor: pointer;
}

.logo span {
  font-weight: 300;
  margin-left: 8px;
  font-size: 1rem;
  opacity: 0.8;
}

.back-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}

.back-btn:hover {
  background: #fff;
  color: #000;
}

.article-hero {
  position: relative;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: brightness(0.4) saturate(1.2);
  transform: scale(1.02);
}

.hero-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: linear-gradient(to top, #050505 10%, transparent);
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
  padding: 0 20px;
}

.article-meta {
  font-size: 0.85rem;
  color: #6d5dfc;
  margin-bottom: 25px;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.dot {
  margin: 0 10px;
  opacity: 0.3;
}

.article-hero h1 {
  font-size: 3.4rem;
  line-height: 1.1;
  margin-bottom: 25px;
  font-weight: 900;
}

.excerpt {
  font-size: 1.25rem;
  opacity: 0.7;
  font-weight: 300;
  line-height: 1.6;
}

.article-container {
  max-width: 900px;
  margin: -60px auto 0;
  position: relative;
  z-index: 10;
  padding: 0 20px 100px;
}

.ai-summary-box {
  background: rgba(109, 93, 252, 0.05);
  border: 1px solid rgba(109, 93, 252, 0.2);
  border-radius: 12px;
  padding: 25px 30px;
  margin-bottom: 50px;
  position: relative;
  overflow: hidden;
}

.ai-summary-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: #6d5dfc;
  box-shadow: 0 0 15px #6d5dfc;
}

.ai-header {
  font-size: 0.9rem;
  color: #6d5dfc;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ai-summary-box p {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.7;
  margin: 0;
}

.markdown-render {
  font-size: 1.15rem;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 300;
}

.markdown-render h2 {
  font-size: 2.2rem;
  margin: 4rem 0 2rem;
  color: #fff;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.markdown-render p {
  margin-bottom: 1.8rem;
}

.simple-footer {
  text-align: center;
  padding: 40px;
  opacity: 0.3;
  font-size: 0.8rem;
  background: #050505;
}

@media (max-width: 768px) {
  .navbar {
    padding: 1rem 2rem;
  }

  .article-hero h1 {
    font-size: 2.2rem;
  }
}
</style>